"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const merge_1 = require("merge");
const TotalPrice_1 = require("../TotalPrice");
const SplitAnchorPrice_style_1 = require("./SplitAnchorPrice.style");
const SplitAnchorPrice = (_a) => {
    var { priceData = [
        {
            label: TotalPrice_1.SplitPriceLabel.leftToPay,
            value: 18.5,
            text: 'Left to pay',
            qaTextId: 'in-split-left-to-pay',
        },
        {
            label: TotalPrice_1.SplitPriceLabel.yourShare,
            value: 12.5,
            text: 'Your share',
            qaTextId: 'in-split-your-share',
        },
    ], currencySymbol = '$', footerText } = _a, props = __rest(_a, ["priceData", "currencySymbol", "footerText"]);
    const { container, priceStyle, taxStyle } = (0, SplitAnchorPrice_style_1.default)();
    const { containerOverrides, priceOverrides, taxOverrides } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Card, { "data-testid": "card", sx: (0, merge_1.merge)(true, container, containerOverrides), children: [priceData.map((item) => {
                if (item.label === 'fullyPaid') {
                    return ((0, jsx_runtime_1.jsx)(material_1.CardContent, { "data-testid": "cardContent", sx: (0, merge_1.merge)(true, priceStyle(item.label), priceOverrides), children: item.text }, item.label));
                }
                return ((0, jsx_runtime_1.jsxs)(material_1.CardContent, { "data-testid": "cardContent", sx: (0, merge_1.merge)(true, priceStyle(item.label), priceOverrides), children: [(0, jsx_runtime_1.jsx)("div", { "data-qa-id": item.qaTextId, children: item.text }), item.value && ((0, jsx_runtime_1.jsxs)("span", { "data-testid": "price", children: [currencySymbol, item.value && Number(item.value) === 0
                                    ? String(parseFloat(String(item.value)).toLocaleString('en-US', {
                                        minimumIntegerDigits: 2,
                                        minimumFractionDigits: 2,
                                    }))
                                    : String(parseFloat(String(item.value)).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                    }))] }))] }, item.label));
            }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "footer", sx: (0, merge_1.merge)(true, taxStyle, taxOverrides), children: footerText })] }));
};
exports.default = SplitAnchorPrice;
